// extracted by mini-css-extract-plugin
export default {"wrapper":"crimeData_wrapper__cFw7l","container":"crimeData_container__OZ0uv","title":"crimeData_title__XGxUj","data":"crimeData_data__fqcTt","total":"crimeData_total__gFHkw"};